const becomeSellerCn = {
  breadcrumbs: {
    home: '首页',
    becomeSeller: '成为卖家'
  },
  hero: {
    title: '成为卖家',
    subtitle: '与乡村集市一起发展您的业务，触达数百万客户',
    cta: '立即开始'
  },
  stats: [
    { value: '50,000+', label: '活跃卖家' },
    { value: '98%', label: '按时付款' },
    { value: '300%', label: '平均销售增长' },
    { value: '4.8/5', label: '卖家满意度' }
  ],
  benefits: {
    title: '销售的好处',
    items: [
      { title: '增加销售', description: '用您的产品触达我们100万+客户' },
      { title: '赚取更多', description: '有竞争力的佣金率和快速付款' },
      { title: '24/7支持', description: '我们专门的卖家支持团队始终与您同在' },
      { title: '安全交易', description: '完全安全和透明的支付系统' },
      { title: '快速设置', description: '24小时内启动您的商店' },
      { title: '销售分析', description: '详细报告和销售跟踪' }
    ]
  },
  steps: {
    title: '如何开始',
    stepNumbers: ['1', '2', '3'],
    items: [
      { title: '注册', description: '使用您的个人信息和业务信息注册' },
      { title: '验证', description: '我们的团队验证您的信息并在24小时内批准' },
      { title: '开始销售', description: '上传产品并开始销售' }
    ]
  },
  cta: {
    title: '今天开始您的数字业务',
    subtitle: '加入乡村集市，将您的业务推向新的高度',
    button: '成为卖家'
  },
  transformDreams: {
    title: '与乡村集市一起实现您的梦想',
    content: [
      '想象一下看着您的业务蓬勃发展——不仅仅是熟悉的面孔，还有来自每个村庄的新客户，每个人都是第一次发现您。在乡村集市，您的产品成为从未在市场上购物过的人们日常生活的一部分。',
      '我们强大的营销深入农村社区，聚集想要支持当地卖家（如您）的邻居和朋友。我们最新的调查揭示了一些令人难以置信的事情：近30%的买家是首次在市场上购物的客户，准备并渴望从您那里购买。',
      '这是您从未有过的机会——与以前无法接触的人联系，欢迎他们进入您的故事，并将您的销售额增长50%到100%或更多。加入乡村集市——不仅仅是一个平台，而是一场运动。',
      '让我们为您的家庭、您的村庄和您的梦想带来希望、机会和繁荣。客户正在等待。现在是您发光的时候了。'
    ]
  }
};

export default becomeSellerCn;
